import { Button, Card, Checkbox, Divider, Flex, Form, Image, Input, Space, theme, Drawer, Modal, Table } from "antd";
import { useForm, useWatch } from "antd/es/form/Form";
import { EyeTwoTone, EyeInvisibleOutlined, GoogleOutlined, ArrowLeftOutlined } from "@ant-design/icons";

import { json, useNavigate } from "react-router-dom";
import SignUpService from "services/signup";

import { useEffect, useState } from "react";
import { useApp } from "contexts/app";
import ImagePicker from "components/pickers/image/ImagePicker"
const signUpService = new SignUpService();


function Register() {
    const { token } = theme.useToken();
    const [form] = useForm();
    const [otpForm] = useForm();
    const { loading, showLoading } = useApp();


    const navigate = useNavigate();
    const [idOtp, setIdOtp] = useState();
    const [isShowOtp, setIshowOpt] = useState(false)

    const email = useWatch("email", { form });
    const agree = useWatch("agree", { form })

    const handleCreate = () => {
        form.submit();
    };
    useEffect(() => {
        //  form.setFieldsValue({ phone: "0911275168", pass: "112233", re_pass: "112233", full_name: "Vũ Văn Toàn", agree: true });

    }, [])


    const onFinish = async () => {

        const data = { ...form.getFieldsValue() };
        showLoading(true);
        var { otp } = await signUpService.signupWithPhone(data);
        // var { otp } = { "otp": { "id": "2247afbb-51b5-46c0-812c-e7692199b208" } };
        setIdOtp(otp.id);
        console.log()
        showLoading(false)
        setIshowOpt(true)

    };

    const onOtpFinish = async () => {
        const data = { ...otpForm.getFieldsValue() };
        console.log({ data, idOtp, post: { id: idOtp, otp: data.otp } });
        showLoading(true);
        try {
            var createdUser = await signUpService.createWithOTP({ id: idOtp, otp: data.otp });
            if (createdUser) {
                navigate("/thank-you")
            }
        } catch (error) {
            alert(error.message)
        }

        showLoading(false)

    }





    return (
        <Card style={{ width: "500px", position: "absolute", top: "0%", left: "50%", transform: "translate(-50%, 0%)", overflow: "scroll" }}>
            <Flex vertical gap={14}>
                <Space direction="vertical" style={{ textAlign: "center" }}>
                    <img width={200} style={{ borderRadius: "8px" }} src="https://storage.googleapis.com/cubebio/default/siprologo.png" />

                    <span style={{ fontSize: token.fontSizeHeading3, fontWeight: "500" }}>Sỉ Pro - Bán sỉ chuyên nghiệp</span>
                    <span>Đăng ký ngay để sở hữu website bán sỉ chuyên nghiệp, tự động hóa mọi thao tác thủ công.  </span>
                </Space>


                <Divider orientation="center" style={{ opacity: "0.9" }}>
                    Copy website mẫu
                </Divider>




                <Space direction="vertical" style={{ textAlign: "center" }}>
                    <Table
                        pagination={false}
                        showHeader={false}
                        columns={[
                            {
                                render: (_, record) => {
                                    return (record.name)
                                }


                            },
                            {
                                render: (_, record) => {
                                    return <Space><Button type="link" onClick={e => window.location = record.url}>Xem </Button> <Button type="link" onClick={e => navigate(`/shop-create?teplate_id=${record.id}`)}>Copy</Button></Space>
                                }


                            }
                        ]}
                        dataSource={[{ id: "111", name: "Kho sỉ ăn vặt", url: "https://anvatthuytien.sipro.store" },
                        { id: "112", name: "Tổng kho gia dụng", url: "https://anvatthuytien.sipro.store" },
                        { id: "113", name: "Kho Buôn Sỉ Váy Thiết Kế", url: "https://anvatthuytien.sipro.store" }
                        ]}
                    >

                    </Table>

                    {/* <Flex gap={8}>
                        <div>Ăn vặt thuỷ tiên</div>
                        <div><Button type="link">Xem</Button></div>
                        <div><Button type="link">Copy</Button></div>
                    </Flex> */}

                </Space>



                <Divider orientation="center" style={{ opacity: "0.9" }}>
                    Hoặc
                </Divider>

                <Button type="primary" style={{ width: "100%" }} onClick={() => navigate("/register")}>
                    Tạo website mới
                </Button>








                <Form layout="vertical" form={form} initialValues={{}} onFinish={() => onFinish("signUp")}>





                    <Flex align="center" justify="center">
                        <span>Nếu bạn đã có tài khoản</span>
                        <Button type="link" onClick={() => navigate("/login")}>
                            Login
                        </Button>
                    </Flex>

                </Form>

            </Flex>
            <Modal
                title="Xác nhận otp"
                closable={{ 'aria-label': 'Custom Close Button' }}
                open={isShowOtp}
                onOk={e => otpForm.submit()}
                onCancel={e => setIshowOpt(false)}
                onClose={e => setIshowOpt(false)}
                okText="Xác nhận"
            >

                <div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>


                    <Form layout="vertical" form={otpForm} initialValues={{}} onFinish={onOtpFinish} style={{ width: 300 }} >

                        <Form.Item
                            label="OTP"
                            name="otp"
                            rules={[
                                {
                                    required: true,
                                },
                                {
                                    pattern: /^[0-9]{4}$/,
                                    message: "OTP must be a 4-digit number",
                                },
                            ]}
                        >
                            <Input.OTP length={4} style={{ width: "100%" }} />
                        </Form.Item>


                    </Form>
                </div>
            </Modal>
        </Card >
    );
}

export default Register;
